import { ButtonDS, GlobalIcon, Typography } from "get-life-storybook-ts";

interface PrecontractualDocsProps {
  translate: (key: string) => string;
}

// TODO: confirmar URL real con Marianna — link público al Set Informativo ProtectLife Plus.
const SET_INFORMATIVO_URL = "https://life5.it/assicurazione-vita-famiglia/";

const PrecontractualDocs = ({ translate }: PrecontractualDocsProps) => {
  return (
    <div className="max-w-[960px] mx-auto my-6 px-4 py-5 border border-gray-200 rounded-lg bg-white flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <Typography
          variant="H3"
          weight="700"
          text={translate("compliance.upsell.it.docs.title")}
          className="text-gray-900"
        />
        <Typography
          variant="BodySmall"
          weight="400"
          text={translate("compliance.upsell.it.docs.subtitle")}
          className="text-gray-600"
        />
      </div>

      {/* Use the design-system button (renders a proper anchor with the icon
          aligned to the label) instead of a hand-rolled inline-flex <a>, which
          was rendering broken. */}
      <ButtonDS
        href={SET_INFORMATIVO_URL}
        target="_blank"
        rel="noopener noreferrer"
        buttonType="secondary"
        size="40"
        leftIcon="DownloadIcon"
        label={translate("compliance.upsell.it.docs.setInformativo")}
        className="self-start"
      />

      <div className="flex items-start gap-2 px-3 py-2 bg-blue-50 rounded-md">
        <GlobalIcon iconName="MailIcon" size="XS" color="#1E40AF" />
        <Typography
          variant="BodyXSmall"
          weight="500"
          text={translate("compliance.upsell.it.docs.durableMedium")}
          className="text-blue-900"
        />
      </div>
    </div>
  );
};

export default PrecontractualDocs;
